import { Check } from "lucide-react";
import { WHY } from "@/lib/content";
import { Reveal, Overline } from "@/components/site/Reveal";

const STATS = [
  { value: "24×7", label: "Technical Support" },
  { value: "100%", label: "Genuine Spare Parts" },
  { value: "On-Time", label: "Project Delivery" },
];

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="grain relative overflow-hidden py-24 md:py-32"
      style={{ background: "#0B3A82" }}
    >
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid gap-16 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <Reveal>
              <Overline dark>Why Choose Us</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tighter text-white sm:text-5xl md:text-6xl">
                Built on safety, speed &amp; craftsmanship.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 max-w-md font-body text-base leading-relaxed text-white/70">
                Sanwariya Elevator combines experienced engineers with genuine
                parts and disciplined processes — so your lift stays safe,
                smooth and reliable for years.
              </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-3 gap-6">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={0.3 + i * 0.1}>
                  <div className="border-t border-white/15 pt-4">
                    <div className="font-display text-3xl font-bold tracking-tight text-[#D89A18] md:text-4xl">
                      {s.value}
                    </div>
                    <div className="mt-1 font-body text-xs uppercase tracking-wider text-white/60">
                      {s.label}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2">
            {WHY.map((w, i) => (
              <Reveal key={w} delay={(i % 2) * 0.06}>
                <div
                  data-testid={`why-item-${i}`}
                  className="group flex h-full items-center gap-4 bg-[#0B3A82] p-6 transition-colors hover:bg-[#082a5f]"
                >
                  <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center bg-[#D89A18] text-[#0B3A82] transition-transform group-hover:scale-110">
                    <Check size={18} strokeWidth={3} />
                  </span>
                  <span className="font-display text-lg font-medium tracking-tight text-white">
                    {w}
                  </span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
